/**
 * Shared Street View (Pegman) configuration for every Google Map in the app.
 *
 * The Maps JS API already owns a StreetViewPanorama per map instance
 * (`map.getStreetView()`), rendered inside the map container and hidden until
 * the Pegman is dropped. These helpers only enable the control and normalise
 * how that built-in panorama behaves, so all maps look and act the same.
 *
 * `google.maps.*` enums are not available until the API script has loaded, so
 * both helpers must be called after `isLoaded` / inside the map `onLoad`.
 */

/** Map options enabling the draggable Pegman control. */
export const getStreetViewMapOptions = (): google.maps.MapOptions => ({
  streetViewControl: true,
  streetViewControlOptions: {
    position: google.maps.ControlPosition.RIGHT_BOTTOM,
  },
})

/** Options applied to the map's built-in panorama once Street View opens. */
export const STREET_VIEW_PANORAMA_OPTIONS: google.maps.StreetViewPanoramaOptions = {
  // Back arrow to return to the map, mirroring google.com/maps behaviour.
  enableCloseButton: true,
  addressControl: true,
  fullscreenControl: true,
  zoomControl: true,
  panControl: true,
  // Device orientation tracking is disorienting on mobile and prompts for
  // motion sensor permissions, so it stays off.
  motionTracking: false,
  motionTrackingControl: false,
}

/**
 * Applies the shared panorama options to a map's built-in Street View.
 * Safe to call on every map load; it never creates a second panorama.
 */
export const configureStreetViewPanorama = (map: google.maps.Map): void => {
  map.getStreetView().setOptions(STREET_VIEW_PANORAMA_OPTIONS)
}
